import { buildApiUrl, withBusinessHeaders } from './apiConfig';

const DUMPING_ADJUSTMENTS_API_URL =
  process.env.REACT_APP_DUMPING_ADJUSTMENTS_API_URL ||
  buildApiUrl('/dumping-adjustments');

export async function fetchDumpingAdjustments() {
  const response = await requestDumpingAdjustmentApi(DUMPING_ADJUSTMENTS_API_URL, {
    fallbackMessage: 'Unable to load dumping adjustments right now.',
  });

  return response.json();
}

export async function createDumpingAdjustment(payload) {
  const response = await requestDumpingAdjustmentApi(DUMPING_ADJUSTMENTS_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to save dumping adjustment right now.',
  });

  return response.json();
}

export async function deleteDumpingAdjustment(id) {
  const response = await requestDumpingAdjustmentApi(`${DUMPING_ADJUSTMENTS_API_URL}/${id}`, {
    method: 'DELETE',
    fallbackMessage: 'Unable to delete dumping adjustment right now.',
  });

  return response.json();
}

export async function createDumpingLock(payload) {
  const response = await requestDumpingAdjustmentApi(`${DUMPING_ADJUSTMENTS_API_URL}/locks`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to lock dumping inventory right now.',
  });

  return response.json();
}

export async function markDumpingSourceDry(payload) {
  const response = await requestDumpingAdjustmentApi(`${DUMPING_ADJUSTMENTS_API_URL}/mark-dry`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    fallbackMessage: 'Unable to mark dumping inventory as dry right now.',
  });

  return response.json();
}

async function requestDumpingAdjustmentApi(url, options) {
  const { fallbackMessage, ...requestOptions } = options;
  let response;

  try {
    response = await fetch(url, {
      ...requestOptions,
      headers: withBusinessHeaders(requestOptions.headers),
    });
  } catch (error) {
    throw new Error(getNetworkErrorMessage(error, fallbackMessage));
  }

  if (!response.ok) {
    const errorPayload = await safeReadJson(response);
    throw new Error(errorPayload?.message || fallbackMessage);
  }

  return response;
}

function getNetworkErrorMessage(error, fallbackMessage) {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return 'You are offline right now. Please reconnect to continue.';
  }

  if (error instanceof TypeError) {
    return 'Unable to reach the server right now. Please check your connection or try again in a moment.';
  }

  return fallbackMessage;
}

async function safeReadJson(response) {
  try {
    return await response.json();
  } catch (error) {
    return null;
  }
}
